export default __webpack_public_path__ + "6a185de46d670bdaae0b1c443d07d6d3.woff2";